import { render, staticRenderFns } from "./AddNewPaySettingsModal.vue?vue&type=template&id=0b13d8ce&scoped=true"
import script from "./AddNewPaySettingsModal.vue?vue&type=script&lang=js"
export * from "./AddNewPaySettingsModal.vue?vue&type=script&lang=js"
import style0 from "./AddNewPaySettingsModal.vue?vue&type=style&index=0&id=0b13d8ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b13d8ce",
  null
  
)

export default component.exports